<template>
    <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
    </base-header>
    <b-container fluid class="mt--7">   
      <div class="mt-5"></div>
      <job-group-table></job-group-table>
    </b-container>
  </div>
</template>

<script>
import JobGroupTable from '@/views/Tables/JobGroupTable.vue';

export default {
    name:'job-groups',
    components:{
        [JobGroupTable.name]:JobGroupTable,
    }
}
</script>

<style>

</style>